<template>
    <ion-grid>
        <ion-row v-if="stage === '2fa'">
            <ion-col>
                <two-factor v-on:logged-in="onLogin" v-on:login-error="onLoginError" v-on:cancel="stage = 'login'"></two-factor>
            </ion-col>
        </ion-row>
        <ion-row v-else>
            <ion-col size-xs="12" style="text-align: center;">
                <ion-card class="floating floating-small" style="margin-bottom: 15px;">
                    <ion-card-header>
                        <ion-card-title>{{ $t('ncrypt.login_page.title') }}</ion-card-title>
                    </ion-card-header>
                    <ion-card-content>
                        <login-form v-on:logged-in="onLogin" v-on:two-factor-next="stage = '2fa'" v-on:login-error="onLoginError"/>
                    </ion-card-content>
                </ion-card>
                <ion-card class="floating floating-small" style="margin-top: 15px;">
                    <ion-card-header>
                        <ion-card-title>{{ $t('ncrypt.register') }}</ion-card-title>
                    </ion-card-header>
                    <ion-card-content>
                        <ion-item lines="none">{{ $t('ncrypt.no_account_yet') }}</ion-item>
                        <ion-item lines="none">
                            <ion-text color="dark">{{ $t('ncrypt.login_sign_up_benefits') }}</ion-text>
                        </ion-item>
                        <br/>
                        <ion-item lines="none">
                            <ion-button color="light" size="default" @click="$router.push({name: 'register'})" shape="round" style="margin: 0 auto;">{{ $t('ncrypt.sign_up') }}</ion-button>
                        </ion-item>
                    </ion-card-content>
                </ion-card>
            </ion-col>
        </ion-row>
    </ion-grid>
</template>

<script>
    import LoginForm from "./LoginForm.vue";
    import {ApiError} from "../../errors/ApiError";
    import TwoFactor from "./TwoFactor";

    export default {
        name: "Login",
        components: {TwoFactor, LoginForm},
        data() {
            return {
                stage: 'login',
            }
        },
        methods: {
            onLogin() {
                if (this.$store.getters.authIntendedUrl) {
                    this.$router.push(this.$store.getters.authIntendedUrl);
                    return;
                }

                this.$router.push({name: 'home'});
            },
            onLoginError(data) {
                new ApiError(data, false);
            },
        },
    }
</script>
